module.exports = __webpack_public_path__ + "static/img/27.65ed7407.gif";